import { c as _c } from "react/compiler-runtime";
import constate from 'constate';
import type React from 'react';
import Dialog from '../../components/dialog';
import Text from '../../components/text';
import useConfirmationDialog from './hooks/use-confirmation-dialog';
export type ConfirmationDialogProps = {
  children: React.ReactNode;
};
export type ConfirmationDialogProviderProps = {
  children: React.ReactNode;
};
const [Provider, useContext] = constate(useConfirmationDialog);
const ConfirmationDialog = ({
  children
}: ConfirmationDialogProps) => {
  const {
    confirmationDialog,
    hide,
    isProcessing,
    startProcessing,
    stopProcessing
  } = useContext();
  return <>
      {children}
      {confirmationDialog && <Dialog open isConfirmation size="compact" title={confirmationDialog.title} noPadding={confirmationDialog.noPadding} onOpenAutoFocus={confirmationDialog.onOpenAutoFocus} preventEscapeKeyDown onClose={() => {
      if (!isProcessing) hide();
    }} primaryButton={{
      label: confirmationDialog.primaryButton.label,
      type: confirmationDialog.primaryButton.type,
      form: confirmationDialog.primaryButton.form,
      loading: isProcessing,
      onClick: async () => {
        if (confirmationDialog.primaryButton.type === 'submit') {
          return confirmationDialog.primaryButton.onClick?.();
        }
        startProcessing();
        try {
          await confirmationDialog.primaryButton.onClick?.();
          hide();
        } finally {
          stopProcessing();
        }
      },
      variant: confirmationDialog.variant === 'destructive' ? 'destructive' : 'primary'
    }} secondaryButton={confirmationDialog.secondaryButton && {
      label: confirmationDialog.secondaryButton.label,
      disabled: isProcessing,
      type: confirmationDialog.secondaryButton.type,
      form: confirmationDialog.secondaryButton.form,
      onClick: () => {
        confirmationDialog.secondaryButton?.onClick?.();
        hide();
      }
    }}>
          {confirmationDialog.children ? confirmationDialog.children : <Text variant="body-2" color="secondary" textAlign="center">
              {confirmationDialog.description}
            </Text>}
        </Dialog>}
    </>;
};
const ConfirmationDialogProvider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Provider><ConfirmationDialog>{children}</ConfirmationDialog></Provider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ConfirmationDialogProvider;
export { useContext as useConfirmationDialog };